<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { computed } from 'vue'
import './assets/style.scss'
import { useHelpers } from '@/shared/lib'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  open: {
    type: Boolean,
    default: false,
  },
  offsetTitle: {
    type: Number,
    default: 0,
  },
  disable: {
    type: Boolean,
    default: false,
  },
})

const { isMobileDevice } = useHelpers()

const open = defineModel({ default: false })
open.value = props.open ?? false

const clickHandler = () => {
  if (props.disable) return

  open.value = !open.value
}

/** Определение слотов */
defineSlots<{
  title?: (props: {}) => any
  default: (props: {}) => any
  append?: (props: {}) => any
}>()

/* Вычисляем отступ для мобильных устройств */
const offset = computed(() => {
  return isMobileDevice() ? props.offsetTitle / 4 : props.offsetTitle
})
</script>

<template>
  <div
    class="v-toggle-panel"
    :class="{ 'v-toggle-panel_active': open, 'v-toggle-panel_disable': disable }"
  >
    <div :style="{ paddingLeft: offset + 'px' }" class="v-toggle-panel__header">
      <div class="v-toggle-panel__title" @click="clickHandler">
        <div class="v-toggle-panel__name">
          <slot name="title">
            {{ title }}
          </slot>
        </div>

        <VIcons v-if="!disable" class="v-icon_arrow" type="keyboard_arrow_down" />
      </div>

      <div class="v-toggle-panel__icons">
        <slot name="append" />
      </div>
    </div>

    <div class="v-toggle-panel__content" v-if="open">
      <slot />
    </div>
  </div>
</template>
